import CatalogView from "@/pages/category/components/CatalogView";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function MovieCategoryPage() {
  usePageMeta(
    "电影 - 日韩欧美影视平台",
    "汇集日韩与欧美最新电影，涵盖动作、科幻、剧情、动画等多种类型，支持按类型、地区、年份筛选与排序，快速找到想看的高分佳片。",
    "电影,欧美电影,日韩电影,最新电影,高分电影,电影推荐",
  );

  return (
    <CatalogView
      type="movie"
      title="电影"
      breadcrumbLabel="电影"
      intro="欧美大作与日韩佳片一网打尽。可按类型、地区与年份自由筛选，并根据最新、热门或评分排序，快速锁定你想看的电影。"
    />
  );
}